export default __webpack_public_path__ + "static/media/martyrdom.ef28246c.png";